// src/components/YouTubeEmbed.jsx
import React, { useMemo } from "react";

const YouTubeEmbed = ({ youtubeId, title = "Lesson video" }) => {
  const src = useMemo(
    () => `https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&modestbranding=1`,
    [youtubeId]
  );

  if (!youtubeId) return null;

  return (
    <div className="video-wrapper">
      <iframe
        title={title}
        src={src}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
};

export default YouTubeEmbed;
